import { Component, PLATFORM_ID, Inject } from '@angular/core';
import { RouterLink, Router } from '@angular/router';
import { CommonModule, isPlatformBrowser, ViewportScroller } from '@angular/common';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [RouterLink, CommonModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  currentYear = new Date().getFullYear();

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private router: Router,
    private viewportScroller: ViewportScroller,
  ) {}

  scrollToTop(): void {
    if (this.router.url !== '/') {
      this.router.navigate(['/']).then(() => {
        if (isPlatformBrowser(this.platformId)) {
          this.viewportScroller.scrollToPosition([0, 0]);
        }
      });
    } else {
      if (isPlatformBrowser(this.platformId)) {
        this.viewportScroller.scrollToPosition([0, 0]);
      }
    }
  }
}
